module.exports = __webpack_public_path__ + "img/logo-light.fcabb6eb.svg";